import * as Bowser from 'bowser';
import { computed } from '@vue/composition-api';

export default function useBrowser() {
  const browser = computed(() => Bowser.parse(window.navigator.userAgent));
  const browserMap = computed(() => Bowser.BROWSER_MAP);
  const osMap = computed(() => Bowser.OS_MAP);
  const engineMap = computed(() => Bowser.ENGINE_MAP);

  return {
    browser,
    browserMap,
    osMap,
    engineMap,
  };
}
